/* eslint-disable no-new */
import { component } from "picoapp";

export default component(async (node, ctx) => {
  const { default: Flickity } = await import("flickity");

  new Flickity(".js-collection-slider", {
    wrapAround: true,
    draggable: true,
    pauseAutoPlayOnHover: false,
    autoPlay: true,
  });

  new Flickity(".js-collection-image-slider", {
    asNavFor: ".js-collection-slider",
    fade: true,
    wrapAround: true,
  });
});
